import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Shuttle move flag.
 *
 * @remarks
 * System-managed flag set during shuttle planning. When true, indicates this move
 * is part of a shuttle sequence (driver takes vehicle to destination, then needs
 * a ride back).
 *
 * Used for:
 * - Use case detection in dispatch-automation
 * - Event detection in event-handlers
 * - Billing exclusion (shuttle moves are not chargeable)
 * - UI styling in admin-portal
 */
export const schema = z.boolean().optional();

export type IsShuttle = z.infer<typeof schema>;

export const definition = define({
  key: 'isShuttle',
  schema,
  label: 'Is Shuttle',
  description:
    'System flag marking this move as part of a shuttle sequence. Set by shuttle planning, not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
